import { render, staticRenderFns } from "./ActionContactDone.vue?vue&type=template&id=b6d243ea&scoped=true"
import script from "./ActionContactDone.vue?vue&type=script&lang=js"
export * from "./ActionContactDone.vue?vue&type=script&lang=js"
import style0 from "./ActionContactDone.vue?vue&type=style&index=0&id=b6d243ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d243ea",
  null
  
)

export default component.exports